import "core-js/modules/es6.array.find-index";
import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/*eslint-disable*/
import repoProject from '@/api/home-manager/project';
var home = {
  namespaced: true,
  state: {
    loading: false,
    // 项目总览数据
    projectData: {},
    // 地图信息
    // 保存地图下钻层级 [{ mapName, mapCode, mapDesc, data }]
    projectMapHistory: [],
    // 全国
    projectMapDesc: '',
    // china
    projectMapName: '',
    // 100000
    projectMapCode: '',
    // {}
    projectMapJson: null
  },
  mutations: {
    SET_PROJECT_DATA: function SET_PROJECT_DATA(state, data) {
      state.projectData = data;
    }
  },
  actions: {
    /**
     * 获取项目总览
     *
     * @param commit
     * @param state
     * @param params
     * @return {Promise<void>}
     */
    loadProjectData: function () {
      var _loadProjectData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref, params) {
        var commit, state, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              state.loading = true;
              _context.next = 4;
              return repoProject.loadReportData(params);
            case 4:
              data = _context.sent;
              state.loading = false;
              commit('SET_PROJECT_DATA', data);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function loadProjectData(_x, _x2) {
        return _loadProjectData.apply(this, arguments);
      }
      return loadProjectData;
    }(),
    /**
     * 加载地图数据
     *
     * @param commit
     * @param state
     * @param dispatch
     * @param params {Object<{ mapName: string, mapCode: string }>}
     * @return {Promise<any>}
     */
    loadMapJsonData: function loadMapJsonData(_ref2, params) {
      var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;
      return new Promise(function (resolve) {
        // 当前激活的index
        var nowIndex = state.projectMapHistory.findIndex(function (history) {
          return history.mapCode === state.projectMapCode;
        });
        // 将要激活的index
        var nextIndex = state.projectMapHistory.findIndex(function (history) {
          return history.mapCode === params.mapCode;
        });
        if (nextIndex > -1) {
          if (nextIndex === nowIndex) {
            resolve(state.projectMapHistory[nextIndex]);
            return;
          } else {
            if (nextIndex > nowIndex) {
              // 前进
              // 暂时不需要处理
            } else {
              // 后退
              var num = state.projectMapHistory.length - (nextIndex + 1);
              for (var i = 0; i < num; i++) {
                state.projectMapHistory.pop();
              }
              var result = state.projectMapHistory[state.projectMapHistory.length - 1];
              dispatch('setMapJsonData', result);
              resolve(result);
              return;
            }
          }
        }
        fetch("/json/echartMap/".concat(params.mapCode, ".json")).then(function (response) {
          if (response.ok) {
            return response.json();
          }
          return null;
        }).then(function (data) {
          var result = {
            mapName: params.mapName,
            mapCode: params.mapCode,
            mapDesc: params.mapName === 'china' ? '全国' : params.mapName,
            data: data
          };
          state.projectMapHistory.push(result);
          dispatch('setMapJsonData', result);
          resolve(result);
        }).catch(function () {
          var result = {
            mapName: params.mapName,
            mapCode: params.mapCode,
            mapDesc: params.mapName === 'china' ? '全国' : params.mapName,
            data: null
          };
          state.projectMapHistory.push(result);
          dispatch('setMapJsonData', result);
          resolve(result);
        });
      });
    },
    /**
     * 设置当前地图数据
     *
     * @param commit
     * @param state
     * @param params {Object<{ mapName, mapCode, mapDesc, data }>}
     */
    setMapJsonData: function setMapJsonData(_ref3, params) {
      var commit = _ref3.commit,
        state = _ref3.state;
      state.projectMapDesc = params.mapDesc;
      state.projectMapName = params.mapName;
      state.projectMapCode = params.mapCode;
      state.projectMapJson = params.data;
    },
    /**
     * 切换地图历史记录
     *
     * @param commit
     * @param state
     * @param item
     */
    dispatchMapHistoryChange: function dispatchMapHistoryChange(_ref4, item) {
      var commit = _ref4.commit,
        state = _ref4.state;
      var event = new CustomEvent('homeProjectMapHistoryChange', {
        detail: item
      });
      window.dispatchEvent(event);
    },
    /**
     * 重置项目地图历史记录
     *
     * @param state
     */
    resetMapHistory: function resetMapHistory(_ref5) {
      var state = _ref5.state;
      state.projectMapHistory = [];
      state.projectMapDesc = '';
      state.projectMapName = '';
      state.projectMapCode = '';
      state.projectMapJson = null;
    }
  }
};
export default home;